module.exports = __webpack_public_path__ + "static/fabric-tooltip-directionalHint-d9b3d380d8cf7497d5674b0c9209a1a4.png";